"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesHttpAdapterV2 = void 0;
var Utility_1 = require("./Utility");
var HttpAdapter_1 = require("./HttpAdapter");
var Registry_1 = require("./Registry");
var GamesHttpAdapterV2 = /** @class */ (function (_super) {
    __extends(GamesHttpAdapterV2, _super);
    function GamesHttpAdapterV2(options) {
        return _super.call(this, options) || this;
    }
    GamesHttpAdapterV2.prototype.getProduct = function () {
        var product = Registry_1.registry.getProduct(this.options.productName);
        if (!product || !product.gamesRegistryEndpoint) {
            throw new Error('Product or gamesRegistryEndpoint is undefined');
        }
        return product;
    };
    // TODO Add DC handling in the future, if needed
    GamesHttpAdapterV2.prototype.getEndpoint = function () {
        var product = this.getProduct();
        switch (this.options.environment) {
            case 'production':
                return product.gamesRegistryEndpoint.production;
            case 'staging':
                return product.gamesRegistryEndpoint.staging;
            case 'dev':
                return product.gamesRegistryEndpoint.dev;
            default:
                throw new Error("Invalid environment: ".concat(this.options.environment));
        }
    };
    GamesHttpAdapterV2.prototype.getEndpointPath = function () {
        var _this = this;
        var product = this.getProduct();
        var endpointPath = product.gamesRegistryEndpoint.endpointPath;
        var endpointPathTemplate = endpointPath.endpointPathTemplate, replacements = endpointPath.replacements;
        var formattedReplacements = {};
        replacements.forEach(function (_a) {
            var replacementKey = _a.replacementKey, replacementOptionsPath = _a.replacementOptionsPath;
            formattedReplacements[replacementKey] = _this.options[replacementOptionsPath];
        });
        return (0, Utility_1.supplant)(endpointPathTemplate, formattedReplacements);
    };
    GamesHttpAdapterV2.prototype.getTranslationsEndpoint = function () {
        if (this.options.environment === 'staging') {
            return 'https://frasier.staging.de-2.nsoft.cloud/translations';
        }
        return 'https://frasier.de-2.nsoft.cloud/translations';
    };
    GamesHttpAdapterV2.prototype.getTranslationsEndpointPath = function (domain) {
        return "/".concat(domain, "/languages/").concat(this.options.locale, "/clients/").concat(this.options.tenantId);
    };
    GamesHttpAdapterV2.prototype.getEndpointHeaders = function () {
        return {};
    };
    GamesHttpAdapterV2.prototype.getEndpointParams = function () {
        return {};
    };
    GamesHttpAdapterV2.prototype.getTranslationsResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var domains, promises, isMultipleDomain, responses, result;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        domains = (0, Utility_1.defaultTo)(this.options.translationDomains, [
                            (_a = this.options.applicationName) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                        ]);
                        promises = domains.map(function (domain) { return __awaiter(_this, void 0, void 0, function () {
                            var url, response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!domain)
                                            return [2 /*return*/];
                                        url = "".concat(this.getTranslationsEndpoint()).concat(this.getTranslationsEndpointPath(domain));
                                        return [4 /*yield*/, this.httpLibrary.get(url)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response.data];
                                }
                            });
                        }); });
                        isMultipleDomain = domains.length > 1;
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        responses = _b.sent();
                        if (isMultipleDomain) {
                            result = {};
                            domains.forEach(function (domain, index) {
                                if (!domain)
                                    return;
                                result[domain] = responses[index];
                            });
                        }
                        else {
                            result = responses[0];
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    GamesHttpAdapterV2.prototype.parseResponse = function (data) {
        var product = this.getProduct();
        var _a = product.gamesRegistryEndpoint.config.mappings || {
            rules: [],
        }, rules = _a.rules, customProperties = _a.customProperties;
        var parsedCustomProperties = {};
        var parsedRules = rules
            .map(function (_a) {
            var _b;
            var name = _a.name, dataPath = _a.dataPath, defaultValue = _a.defaultValue;
            return (_b = {},
                _b[name] = { name: name, value: (0, Utility_1.defaultTo)(data[dataPath], defaultValue) },
                _b);
        })
            .reduce(function (acc, rule) { return (__assign(__assign({}, acc), rule)); }, {});
        if (customProperties) {
            parsedCustomProperties = customProperties
                .map(function (_a) {
                var _b;
                var name = _a.name, dataPath = _a.dataPath, defaultValue = _a.defaultValue;
                return (_b = {},
                    _b[name] = (0, Utility_1.defaultTo)(data[dataPath], defaultValue),
                    _b);
            })
                .reduce(function (acc, rule) { return (__assign(__assign({}, acc), rule)); }, {});
        }
        return __assign(__assign({ rules: parsedRules }, parsedCustomProperties), { productInstanceUuid: data.productInstanceId, translations: data.translations, taxes: {
                payin: { policy: data.payInTax },
                payout: { policy: data.payoutTax },
            }, rawData: data });
    };
    GamesHttpAdapterV2.prototype.getResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.getEndpoint()).concat(this.getEndpointPath());
                        return [4 /*yield*/, this.httpLibrary.get(url, {
                                headers: this.getEndpointHeaders(),
                                params: this.getEndpointParams(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    GamesHttpAdapterV2.prototype.getConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promisesArr, product, responses, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promisesArr = [this.getResponse()];
                        product = this.getProduct();
                        if (product.name !== 'vdr') {
                            promisesArr.push(this.getTranslationsResponse());
                        }
                        return [4 /*yield*/, Promise.all(promisesArr)];
                    case 1:
                        responses = _a.sent();
                        data = responses[0].data;
                        data.translations = responses[1];
                        return [2 /*return*/, this.parseResponse(data)];
                }
            });
        });
    };
    return GamesHttpAdapterV2;
}(HttpAdapter_1.HttpAdapter));
exports.GamesHttpAdapterV2 = GamesHttpAdapterV2;
//# sourceMappingURL=GamesHttpAdapterV2.js.map